import { useDispatch } from 'react-redux';
import Pluralize from 'react-pluralize';
import Numeral from '../numeral';
import { StyledShipping } from './style';
import Icon from '../icon';
import { LinkButton } from '../button';
import { showShippingModal } from '../../reducers/shippingModal';

const Shipping = (props) => {
  const dispatch = useDispatch();
  
  const handleQuestionClick = () => {
    dispatch(showShippingModal());
  }

  if(props.shippingPrice >= 0) {
    return (
      <StyledShipping>
        <div className="item">
          Frete: <strong><Numeral value={props.shippingPrice} format="$ 0,0.00" /></strong>
        </div>
        <div className="item">
          Prazo: <strong>
            <Pluralize singular="dia útil" plural="dias úteis" count={props.deliveryTime} />
          </strong> <LinkButton onClick={handleQuestionClick}>
            <Icon icon="question-circle" />
          </LinkButton>
        </div>
      </StyledShipping>
    )
  }
  else return null;
}

export default Shipping;
